import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { getInitials } from '#client/utils/text';

import { IconBorderStyled } from './styles';

export default function IconName({
  name,
  disabled = false,
  numberOfCharacters = 2,
  circle = false
}) {
  const firstCharacters = getInitials(name, numberOfCharacters);

  return (
    <IconBorderStyled
      circle={circle}
      disabled={disabled}
    >
      <Text
        color="white"
        size="lg"
        weight="medium"
      >
        {firstCharacters}
      </Text>
    </IconBorderStyled>
  );
}

IconName.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  circle: PropTypes.bool,
  numberOfCharacters: PropTypes.number
};
